import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api, { fileUrl } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { SectionTitle } from "@/components/Bits";

export default function Vendors() {
  const { t, L } = useLang();
  const [vendors, setVendors] = useState([]);
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    api.get("/vendors").then((r) => setVendors(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const shown = vendors.filter((v) => cat === "all" || v.category === cat);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
      <SectionTitle tag="VENDORS · 市集摊主" title={t("vendors_title")} />

      <div className="flex flex-wrap gap-2 mb-8">
        <button onClick={() => setCat("all")} className={`fk-border rounded-full px-4 py-2 text-sm font-semibold ${cat === "all" ? "bg-black text-white" : "bg-white fk-lift"}`}>{t("all")}</button>
        {cats.map((c) => (
          <button key={c.id} onClick={() => setCat(c.name_zh)} data-testid={`vendor-cat-${c.name_zh}`} className={`fk-border rounded-full px-4 py-2 text-sm font-semibold ${cat === c.name_zh ? "bg-black text-white" : "bg-white fk-lift"}`}>{L(c.name_zh, c.name_en)}</button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {shown.map((v, i) => (
          <motion.div key={v.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}>
            <Link to={`/vendors/${v.slug}`} data-testid={`vendor-card-${v.id}`} className="block bg-white fk-border-thick rounded-2xl overflow-hidden fk-lift">
              <img src={fileUrl(v.photos?.[0]) || "https://images.unsplash.com/photo-1777846800324-0cbb1124fb9a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"} alt={v.name_en} className="w-full h-48 object-cover border-b-2 border-black" />
              <div className="p-5">
                <span className="font-mono-fk text-xs fk-border rounded-full px-2.5 py-1 bg-[#FFD93D]">{v.category}</span>
                <h3 className="font-display text-xl mt-3">{L(v.name_zh, v.name_en)}</h3>
                <p className="mt-1 text-sm text-black/60 line-clamp-2">{L(v.bio_zh, v.bio_en)}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
      {shown.length === 0 && <p className="text-black/50 font-mono-fk">暂无摊主 / No vendors yet.</p>}
    </div>
  );
}
